/**
 * Starting a GitHub App installation. Pure (no React, no network client), so
 * it is tested without a DOM.
 *
 * The install link must carry a `state` the backend issued to this user of
 * this workspace (POST /github/auth/state, single-use, short-lived). GitHub
 * returns it on the post-install redirect, and the callback refuses a
 * redirect without it, so a link nobody in this session started cannot bind
 * an installation to the workspace.
 */

export const DEFAULT_GITHUB_APP_INSTALL_URL =
  'https://github.com/apps/systemdox-connector/installations/new';

/** The install URL with `state` set (any existing query is kept). */
export function buildInstallUrl(base: string, state: string): string {
  const url = new URL(base);
  url.searchParams.set('state', state);
  return url.toString();
}

/**
 * Issue a state, then go to GitHub with it. Nothing navigates without one:
 * a failure to issue it is thrown to the caller, which shows it.
 */
export async function startGitHubInstall(io: {
  base: string;
  issueState: () => Promise<{ state: string }>;
  navigate: (url: string) => void;
}): Promise<void> {
  const { state } = await io.issueState();
  if (!state) throw new Error('Could not start the GitHub connection. Try again.');
  io.navigate(buildInstallUrl(io.base, state));
}
